import { setForgerockConfig } from "@/utils/Auth/forgeRockService.service";
import { FRUser, TokenManager, UserManager } from "@forgerock/javascript-sdk";
import { datadogRum } from '@datadog/browser-rum';
import {
  AUTH_ERROR,
  JOURNEY_LOGIN_NORMAL,
  TIMEOUT,
} from "@/utils/Auth/authConstants";
import {
  clearForgeRockAuthInfo,
  setForgeRockAuthInfo,
  setForgeRockToken,
} from "@/redux/dataSlice";

interface User {
  email?: string;
  given_name?: string;
  family_name?: string;
  educationId?: string;
}

export function userLogout(dispatch, router) {
  try {
    dispatch(clearForgeRockAuthInfo());
    setForgerockConfig(JOURNEY_LOGIN_NORMAL);
    FRUser.logout();
    router.push("/parent/login");
  } catch (e) {
    console.log("Error during logout: ", e);
  }
}

export function clearAuthInfoData(dispatch) {
  try {
    dispatch(clearForgeRockAuthInfo());
    setForgerockConfig(JOURNEY_LOGIN_NORMAL);
    FRUser.logout();
  } catch (e) {
    console.log("Error during clearAuthInfoData: ", e);
  }
}

export async function generateNewToken(dispatch: Function) {
  try {
    console.log("<--- Updating Token --->");
    setForgerockConfig(JOURNEY_LOGIN_NORMAL);
    const newToken = await TokenManager.getTokens({
      forceRenew: false,
    });

    dispatch(setForgeRockToken(newToken));

    console.log("<--- Token Updated --->");
  } catch (error) {
    if (error?.message?.includes("Authorization timed out")) {
      console.log("Authorization timed out");
      return TIMEOUT;
    } else {
      return AUTH_ERROR;
    }
  }
}

export async function getUserInfoDetails(dispatch: Function) {
  try {
    setForgerockConfig(JOURNEY_LOGIN_NORMAL);

    const newToken = await TokenManager.getTokens({
      forceRenew: false,
    });

    const user = (await UserManager.getCurrentUser()) as User;

    

    dispatch(
      setForgeRockAuthInfo({
        userEmail: user?.email,
        userPassword: null,
        getToken: newToken,
        responsePayload: null,
        givenName: user?.given_name,
        familyName: user?.family_name,
        educationId: user?.educationId,
      })
    );

    setDatadogUserInfoDetails(user); // added for datadog logs

    return user;
  } catch (error) {
    if (error?.message?.includes("Authorization timed out")) {
      console.log("Authorization timed out");
      return TIMEOUT;
    } else {
      console.log("Authorization error", error);
    }
  }
}


export async function setDatadogUserInfoDetails(user: User | null) {
  if (!user) return;  

  datadogRum.setUser({
    sfid: user?.educationId,       
    givenName: user?.given_name,  
    familyName: user?.family_name,  
    userEmail: user?.email,
  });
}
